import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { Home365Note, Home365SaveNoteFunc, chatRecordModel } from "../../../shared/classes";
import { SharedService } from "../../../shared/services/shared.service";
import { catchError, concatMap, map, of, switchMap, take } from "rxjs";
import { ChatService } from "../../../shared/services/chat.service";

@Component({
  selector: 'chat-input',
  templateUrl: './chatInput.component.html',
  styleUrls: ['./chatInput.component.scss']
})
export class ChatInputComponent implements OnInit {
  @Input() task_ticket_id: any;
  @Output() noteAdded = new EventEmitter<Home365Note>();
  @Output() onFilesUploaded = new EventEmitter<any>();
  @Input() chatType: string = 'task'
  @Input() heightCarousel: number = 100;
  @Input() disabled: boolean = false;
  @Input() userData: any
  isMobile: boolean = false;

  constructor(
    private sharedService: SharedService,
    private cd: ChangeDetectorRef,
    private chatService: ChatService
  ) {
  }

  saveNote: Home365SaveNoteFunc = (note: any) => this.onSaveNote(note);

  ngOnInit() {
    this.isMobile = this.sharedService.isMobile;
  }

  filesUploaded(value: any) {
    this.onFilesUploaded.emit(value)
  }

  onSaveNote(note: Home365Note) {
    this.sharedService.changeMessage({ action: 'loading', actionData: true })
    //console.log('on save note', note);
    let body: chatRecordModel = {
      message: note.note,
      senderId: note.user.id,
      senderName: note.user.name,
      ticketId: this.task_ticket_id,
      pipelineLabel: 'Service',
      attachments: note.files?.map(item => {
        return {url: item.fileUrl, fileName: item.fileName}
      })
    }
    return this.chatService.createTicketRecord(body).pipe(
      take(1),
      switchMap((res) => {
        return this.chatService.updateTicketSatge(this.task_ticket_id,this.userData.id).pipe(
          take(1),
          map((res) => {
            this.sharedService.changeMessage({ action: 'loading', actionData: false })
            this.noteAdded.emit(note);
            this.cd.detectChanges();
            return note
          }),
          catchError((err) => {
            this.sharedService.changeMessage({ action: 'loading', actionData: false })
            this.sharedService.changeMessage({ action: 'popup', actionData: 'error' })
            return of(note)
          }))
        }),
        catchError((err) => {
          this.sharedService.changeMessage({ action: 'loading', actionData: false })
          this.sharedService.changeMessage({ action: 'popup', actionData: 'error' })
          return of(note)
        })
      )
  }


  openNewTicket() {
    this.sharedService.changeMessage({action: 'openNewTicket'})
  }

}
